import { Component, EventEmitter, Inject, OnDestroy, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NbToastrService, NbWindowRef, NB_WINDOW_CONTEXT } from '@nebular/theme';
import { OnDestroyMixin } from '@w11k/ngx-componentdestroyed';
import GalleryJson from '../../../../assets/data/gallery_photos.json';
import { DishGalleryWindowContext } from './dish-gallery-window-context';

@Component({
    selector: 'ngx-dish-images-templates',
    templateUrl: './dish-images-templates.component.html',
    styleUrls: ['./dish-images-templates.component.scss'],
    standalone: false
})

export class DishImagesTemplatesComponent extends OnDestroyMixin implements OnInit, OnDestroy {

    @Output() selectedUrl: EventEmitter<string> = new EventEmitter<string>();

    constructor(
        private windowRef: NbWindowRef,
        private translate: TranslateService,
        @Inject(NB_WINDOW_CONTEXT) private context: DishGalleryWindowContext
    )
    {
        super();
    }

    urls = GalleryJson;

    ngOnInit() {

    }

    select(e: MouseEvent) {
        e.preventDefault();
        this.close();
        this.selectedUrl.next((e.target as HTMLImageElement).currentSrc);
        this.context.onImageSelected.next((e.target as HTMLImageElement).currentSrc);
    }

    close() {
        this.windowRef.close();
    }
}